import { render, staticRenderFns } from "./MultiPart.vue?vue&type=template&id=778dbdf9&scoped=true&"
import script from "./MultiPart.vue?vue&type=script&lang=ts&"
export * from "./MultiPart.vue?vue&type=script&lang=ts&"
import style0 from "./MultiPart.vue?vue&type=style&index=0&id=778dbdf9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778dbdf9",
  null
  
)

export default component.exports